export const PROCESS_STATUS = Object.freeze({
  DRAFT: 'BORRADOR',
  PENDING: 'PENDIENTE_APROBACION',
  APPROVED: 'APROBADO',
  CLOSED: 'CERRADO',
  CANCELLED: 'CANCELADO'
})

export const PROCESS_STATUS_OPTIONS = Object.freeze([
  { value: PROCESS_STATUS.DRAFT, title: 'Borrador', color: 'secondary' },
  { value: PROCESS_STATUS.PENDING, title: 'Pendiente de aprobacion', color: 'warning' },
  { value: PROCESS_STATUS.APPROVED, title: 'Aprobado', color: 'info' },
  { value: PROCESS_STATUS.CLOSED, title: 'Cerrado', color: 'success' },
  { value: PROCESS_STATUS.CANCELLED, title: 'Cancelado', color: 'error' }
])

export function getProcessStatus (value) {
  return PROCESS_STATUS_OPTIONS.find(option => option.value === value) || { value, title: 'Estado no reconocido', color: 'error' }
}
